import { render, staticRenderFns } from "./UserAdminModal.vue?vue&type=template&id=15c3735a&"
import script from "./UserAdminModal.vue?vue&type=script&lang=js&"
export * from "./UserAdminModal.vue?vue&type=script&lang=js&"
import style0 from "./UserAdminModal.vue?vue&type=style&index=0&id=15c3735a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports